export default __webpack_public_path__ + "static/media/logo.3c76dd47.webp";